import { t } from "@/lib/i18n";

const inputCls = "w-full min-h-[48px] rounded-xl border bg-white px-4 py-3 text-base text-ink placeholder:text-stone-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-honey";

function Field({ k, label, hint, error, optional, ...props }) {
  const id = `booking-${k}`;
  const describedBy = [hint && `${id}-hint`, error && `${id}-error`].filter(Boolean).join(" ") || undefined;
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="block text-sm font-semibold text-wood">
        {label} {optional && <span className="font-normal text-ink-muted">({t("bilet.contact.optional")})</span>}
      </label>
      <input id={id} aria-invalid={!!error} aria-describedby={describedBy} className={`${inputCls} ${error ? "border-[#B42318]" : "border-line"}`} data-testid={`booking-${k}-input`} {...props} />
      {hint && <p id={`${id}-hint`} className="text-xs text-ink-muted">{hint}</p>}
      {error && <p id={`${id}-error`} className="text-sm text-[#B42318]" data-testid={`booking-${k}-error`}>{error}</p>}
    </div>
  );
}

export default function ContactStep({ v, set, errors }) {
  const on = (k) => (e) => set({ [k]: e.target.value });
  return (
    <div className="grid gap-5 sm:grid-cols-2 max-w-3xl" data-testid="booking-contact-step">
      <Field k="name" label={t("bilet.contact.name")} error={errors.name} type="text" autoComplete="name" value={v.name} onChange={on("name")} />
      <Field k="phone" label={t("bilet.contact.phone")} error={errors.phone} type="tel" inputMode="tel" autoComplete="tel" value={v.phone} onChange={on("phone")} />
      <Field k="email" label={t("bilet.contact.email")} hint={t("bilet.contact.emailHint")} error={errors.email} type="email" inputMode="email" autoComplete="email" value={v.email} onChange={on("email")} />
      <Field k="plate" label={t("bilet.contact.plate")} hint={t("bilet.contact.plateHint")} error={errors.plate} optional type="text" autoCapitalize="characters" autoComplete="off" value={v.plate} onChange={on("plate")} />
      <div className="absolute -left-[9999px] h-px w-px overflow-hidden" aria-hidden="true">
        <label htmlFor="booking-website">Web sitesi</label>
        <input id="booking-website" type="text" tabIndex={-1} autoComplete="off" value={v.website} onChange={on("website")} data-testid="booking-honeypot" />
      </div>
    </div>
  );
}
